import { useCallback } from "react";
import { TableColumn } from "@components/Table/TableColumns";
import { COMMON_NUM_COL_WIDTH } from "@core/constants";
import { KeywordTableColumn } from "@api/useGetKeywordBaseData";
import { AmongType, getAmongTypeKey, useGetAmongTypeData } from "@models/Among";

export function useGetAmongNormTableCell (
    data: Array<{
        columns: Map<string, KeywordTableColumn<number>>;
    }>,
) {
    const getAmongTypeData = useGetAmongTypeData();

    return useCallback(
        (optionId: number, type: AmongType, keySuffix = 'norm'): TableColumn => {
            const key = getAmongTypeKey(optionId, type);
            const amongTypeData = getAmongTypeData(optionId, type);

            return {
                key: `among-${type}-${optionId}-${keySuffix}`,
                head: amongTypeData?.name ?? '',
                headText: amongTypeData?.name ?? '',
                Value: ({ index }) => <>
                    {data[index].columns.get(key)?.norm ?? '-'}
                </>,
                valueText: (index) => `${data[index].columns.get(key)?.norm ?? '-'}`,
                style: {
                    cell: {
                        flex: `0 0 ${COMMON_NUM_COL_WIDTH}`,
                        justifyContent: "center",
                        textAlign: "center",
                        wordBreak: "break-word",
                        overflow: "hidden",
                    }
                }
            };
        },
        [data, getAmongTypeData]
    );
}